module.exports = __webpack_public_path__ + "static/img/shanshan.24df607.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/shanshan.png
// module id = OLKC
// module chunks = 0